import { baseAPI } from "../../services/api";
import { transactionID } from "../../services/helpers";

export async function listCardsRequest({ msisdn, authToken }) {
  return baseAPI.post("/v2/GetCard", {
    MSISDN: msisdn,
    transactionId: transactionID("GCL")
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  });
}